<template lang="pug">
v-dialog(v-model="value", scrollable, persistent, max-width=640)
    v-card 
        v-card-title {{ $t('Bills.__RecordPayment') }}
        v-card-subtitle {{ subtitle }}
        v-card-text 
            //- .text.mb-2 {{$t('Bills.__RecordPaymentReceivedHint')}}
            //- Alert
            v-form(v-model="formValid", ref="recordform")
                .field-label 
                    span {{ $t('Bills.__PaymentDate') }}
                    span.required *
                v-menu(
                    v-model="dateMenu",
                    offset-y,
                    :close-on-content-click="false",
                    :nudge-right="40",
                    transition="scale-transition",
                    min-width="290px"
                )
                    template(v-slot:activator="{ on }")
                        v-text-field(
                            v-model="payment.date",
                            clearable,
                            solo,
                            dense,
                            outlined,
                            readonly,
                            append-icon="event",
                            v-on="on",
                            :placeholder="$t('Placeholder.__Date')",
                            :rules="[rules.required]"
                        )
                    v-date-picker(
                        v-model="payment.date",
                        @input="dateMenu = false"
                        :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''"
                    )
                .field-label 
                    span {{ $t('Bills.__PaymentAmount') }}
                    span.required *
                v-text-field(
                    v-model.number="payment.amount",
                    solo,
                    dense,
                    outlined,
                    type="number",
                    :rules="[rules.required]"
                )
                .field-label 
                    span {{ $t('Bills.__PaymentAccount') }}
                    span.required *
                AccountSelector(
                    v-model="payment.paymentAccountId",
                    :rules="[rules.required]"
                )
                //- .hint.mb-4 Any account into which you deposit and withdraw funds from. Learn more.
                .field-label
                    span {{ $t('Bills.__Notes') }}
                v-textarea(
                    v-model="payment.note",
                    solo,
                    outlined,
                    height="80",
                    :placeholder="$t('Bills.__Notes')"
                )

        v-card-actions.justify-center.mb-6
            v-btn.mr-6(
                rounded,
                dark,
                @click="closeDialog()",
                color="lightGray",
                min-width="112"
            ) {{ $t('ActionOption.__Cancel') }}
            v-btn(
                rounded,
                dark,
                @click="recordBillPayment",
                color="primary",
                min-width="112"
            ) {{ $t('ActionOption.__Confirm') }}
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: String,
      default: null
    },
    amount: {
      type: Number,
      default: 0
    },
    subtitle: {
      type: String,
      default: ""
    },
    customer: {
      type: Object,
      default: () => {
        return { name: "" }
      }
    },
    confirmAction: {
      type: Function,
      default: () => {}
    },
    invoiceId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false,
      dateMenu: false,
      formValid: false,
      rules: textfieldUtils.rules,
      payment: {}
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (this.$refs.recordform != undefined) {
          this.$refs.recordform.resetValidation()
        }
        if (this.recordId != null) {
          this.getPaymentRecord(this.recordId)
        } else {
          this.payment = {}
          this.payment.amount = this.amount
        }
      }
    }
  },
  methods: {
    recordBillPayment() {
      this.$refs.recordform.validate()
      if (this.formValid) {
        this.payment.id = this.invoiceId
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("bills/recordBillPayment", this.payment)
          .then(
            function(response) {
              this.confirmAction()
              this.$store.dispatch("global/stopLoading")
              this.closeDialog()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    },

    closeDialog() {
      this.$emit("input", false)
      this.payment = {}
    }
  },
  // updated() {
  //     if (this.$refs.recordform != undefined && this.show) {
  //         this.$refs.recordform.resetValidation()
  //         this.show = false
  //     }
  // },
  computed: {},

  mounted() {
    this.$store.dispatch("global/closeAlert")
  }
}
</script>
